export default __webpack_public_path__ + "static/contact-tab-three-dba00962f425f92b4dd6d38954788bfa.jpg";